"use client";

import { useFormState, useFormStatus } from "react-dom";

import { unlockPage, type UnlockPageState } from "@/app/actions/unlock-page";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

type Props = {
  slug: string;
  misconfigured?: boolean;
};

const initialState: UnlockPageState = { ok: false };

function SubmitButton() {
  const { pending } = useFormStatus();
  return (
    <Button disabled={pending} type="submit" variant="default">
      {pending ? "Controleren..." : "Ontgrendelen"}
    </Button>
  );
}

export default function PasswordGate({ slug, misconfigured = false }: Props) {
  const [state, formAction] = useFormState(unlockPage, initialState);

  return (
    <div className="container py-12 md:py-20">
      <div className="mx-auto max-w-[600px] rounded bg-nsc-dark-blue px-[10px] py-12 text-white md:p-10 lg:p-16">
        <h2 className="header-2 mb-6 !leading-[41px] md:!leading-[75px]">
          Beveiligde pagina
        </h2>
        {misconfigured ? (
          <p className="body-xl text-white">
            Deze pagina is tijdelijk niet beschikbaar. Neem contact op met de beheerder.
          </p>
        ) : (
          <>
            <p className="body-xl mb-8 text-white">
              Deze pagina is beveiligd met een wachtwoord. Vul het wachtwoord in om toegang te krijgen.
            </p>
            <form action={formAction} className="grid grid-cols-1 gap-6">
              <input type="hidden" name="slug" value={slug} />
              <div className="grid w-full items-center gap-1.5">
                <Label htmlFor="page-password">Wachtwoord</Label>
                <Input
                  id="page-password"
                  name="password"
                  type="password"
                  autoComplete="current-password"
                  required
                  className="text-nsc-dark-blue"
                />
              </div>
              {state.error && !state.ok && (
                <p className="body text-red-300" role="alert">
                  {state.error}
                </p>
              )}
              <div className="grid w-full items-center gap-1.5">
                <SubmitButton />
              </div>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
